import { takeLatest } from "redux-saga/effects"
import {
  ADD_AWARD_NOMINATION_REQUEST,
  CREATE_ORDER_AWARD_NOMINATION_REQUEST,
  GET_AWARD_DETAILS_REQUEST,
  GET_AWARDS_LIST_REQUEST,
  GET_AWARDS_CATEGORY_LIST_REQUEST,
  GET_NOMINATION_DETAILS_REQUEST,
  GET_NOMINATION_LIST_REQUEST,
  UPDATE_NOMINATION_REQUEST,
  VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST,
  ADD_AWARD_SHORTLISTED_DETAILS_REQUEST,
  ADD_AWARD_REQUEST,
  UPDATE_AWARD_REQUEST,
  ADD_AWARD_CATEGORY_REQUEST,
  UPDATE_AWARD_CATEGORY_REQUEST,
} from "../../types/awards"
import {
  addAwardNominationWorker,
  createOrderAwardNominationWorker,
  getAwardDetailsWorker,
  getAwardsListWorker,
  getAwardsCategoryListWorker,
  getNominationDetailsWorker,
  getNominationListWorker,
  updateNominationWorker,
  verifyAwardNominationPaymentWorker,
  addAwardShortlistedDetailsWorker,
  addAwardWorker,
  updateAwardWorker,
  addAwardCategoryWorker,
  updateAwardCategoryWorker,
} from "../workers/awardsWorker"

// Watcher Saga
// Listens for actions and triggers worker sagas
export default function* awardsWatcher() {
  // USERS
  yield takeLatest(GET_AWARD_DETAILS_REQUEST, getAwardDetailsWorker)
  yield takeLatest(ADD_AWARD_NOMINATION_REQUEST, addAwardNominationWorker)
  yield takeLatest(
    CREATE_ORDER_AWARD_NOMINATION_REQUEST,
    createOrderAwardNominationWorker
  )
  yield takeLatest(
    VERIFY_AWARD_NOMINATION_PAYMENT_REQUEST,
    verifyAwardNominationPaymentWorker
  )
  yield takeLatest(
    ADD_AWARD_SHORTLISTED_DETAILS_REQUEST,
    addAwardShortlistedDetailsWorker
  )

  // ADMIN
  yield takeLatest(GET_AWARDS_LIST_REQUEST, getAwardsListWorker)

  yield takeLatest(GET_NOMINATION_LIST_REQUEST, getNominationListWorker)

  yield takeLatest(GET_NOMINATION_DETAILS_REQUEST, getNominationDetailsWorker)

  yield takeLatest(
    GET_AWARDS_CATEGORY_LIST_REQUEST,
    getAwardsCategoryListWorker
  )

  yield takeLatest(UPDATE_NOMINATION_REQUEST, updateNominationWorker)

  yield takeLatest(ADD_AWARD_REQUEST, addAwardWorker)
  yield takeLatest(UPDATE_AWARD_REQUEST, updateAwardWorker)
  yield takeLatest(ADD_AWARD_CATEGORY_REQUEST, addAwardCategoryWorker)
  yield takeLatest(UPDATE_AWARD_CATEGORY_REQUEST, updateAwardCategoryWorker)
}
